import BaseComponent from 'scripts/BaseComponent.js';

export default class Video extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      video: '.js-video',
      source: '.js-source',
      videoControl: '.js-videoControl',
    };

    this.dom = {
      $component: component,
      $video: this.$get(this.refs.video),
      $source: this.$get(this.refs.source),
      $videoControl: this.$get(this.refs.videoControl),
    };

    this.state = {
      isMobileTablet: null,
      observer: false,
      observerConfig: {
        rootMargin: '250px',
        threshold: 0.01,
      },
      pausedVideoClass: 'is-paused',
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();
    this.setMobileBreakpoint();
    this.observe();

    this.setClick(dom.$videoControl, this.toggleVideoPlay);
  }

  setMobileBreakpoint() {
    const { dom, state } = this;
    const { customBreakpoint } = dom.$component.dataset;
    const breakpoint = customBreakpoint || 1024;
    state.isMobileTablet = window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
  }

  observe() {
    const { dom, state } = this;
    state.observer = new IntersectionObserver(this.onIntersection.bind(this), state.observerConfig);
    state.observer.observe(dom.$component);
  }

  onIntersection(entries) {
    const { state: { observer } } = this;
    const entry = entries[0];

    if (entry.isIntersecting) {
      this.load();
      observer.unobserve(entry.target);
    }
  }

  load() {
    const { dom } = this;
    const key = this.getSrcKey();
    const src = dom.$source.getAttribute(key) || false;

    if (src) {
      dom.$source.setAttribute('src', src);
      this.playVideo();
    }
  }

  getSrcKey() {
    const { dom, state } = this;

    const hasMobileKey = (Object.keys(dom.$source.dataset).indexOf('mobileSrc') !== -1);
    const key = (hasMobileKey && state.isMobileTablet) ? 'data-mobile-src' : 'data-src';
    return key;
  }

  async playVideo() {
    const { dom } = this;

    dom.$video.load();

    try {
      await dom.$video.play();
      this.dispatchCustomEvent();
      console.log('Video : video played', this);
    } catch (e) {
      console.log('Video : playVideo error', e);
    }
  }

  toggleVideoPlay() {
    const { dom, state } = this;

    if (dom.$video.paused) {
      dom.$video.play();
      dom.$videoControl.classList.remove(state.pausedVideoClass);
    } else {
      dom.$video.pause();
      dom.$videoControl.classList.add(state.pausedVideoClass);
    }
  }

  dispatchCustomEvent() {
    const { dom: { $component } } = this;
    const { customStartEvent } = $component.dataset;

    if (!customStartEvent) return;
    this.dispatch(customStartEvent);
  }
}
